import React from 'react'
import { PUBLIC_IMAGE_PATH } from "../utils/Constants";
export default function Nopage() {
  return (
    <div style={{textAlign: "center"}}>
        <img alt="404page" src={`${PUBLIC_IMAGE_PATH}404.png`}></img>
    </div>
  )
}
